/* House of Holo - product page + basket */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.querySelector('[data-cart-drawer]');
  var onCartPage = !!document.querySelector('[data-cart-page]');

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var thumbs = pdp.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        pdp.querySelectorAll('[data-slide]').forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== i; });
      });
    });
    /* quantity stepper */
    pdp.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var max = parseInt(input.getAttribute('max') || '99', 10);
          var n = Math.min(max, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10)));
          input.value = n;
        });
      });
    });
    /* delivery / collection preference saved on the basket */
    pdp.querySelectorAll('[data-ful]').forEach(function (r) {
      r.addEventListener('change', function () {
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { 'Preferred fulfilment': r.value === 'Collect' ? 'Collect in store' : 'Delivery' } }) });
      });
    });
    /* sticky bar only once the main button has scrolled away */
    var sticky = document.querySelector('[data-sticky]');
    var cta = pdp.querySelector('.pdp__cta');
    if (sticky && cta) {
      var ticking = false;
      var upd = function () { ticking = false; sticky.classList.toggle('is-hidden', cta.getBoundingClientRect().bottom > 0); };
      var req = function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      upd();
    }
  });

  /* ---------- basket drawer ---------- */
  var setCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    document.querySelectorAll('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Basket, ' + n + ' items'); });
  };
  var openDrawer = function () {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-cart-close]:not(.cdrawer__scrim)');
    if (c) c.focus();
  };
  var closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };
  var swap = function (html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer] .cdrawer__panel');
    if (fresh) drawer.querySelector('.cdrawer__panel').innerHTML = fresh.innerHTML;
  };
  var refresh = function () {
    return fetch(root + '?sections=hoh-cart-drawer').then(function (r) { return r.json(); }).then(function (j) { swap(j['hoh-cart-drawer']); });
  };
  var count = function () {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
  };

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-link]');
    if (link && drawer && !onCartPage) { e.preventDefault(); refresh().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var q = e.target.closest('[data-cq]');
    if (q) {
      var line = q.closest('[data-key]');
      q.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-cq'), 10), sections: 'hoh-cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j.status && j.description) { alertMsg(j.description); q.disabled = false; return; }
        if (onCartPage) { window.location.reload(); return; }
        setCount(j.item_count);
        if (j.sections) swap(j.sections['hoh-cart-drawer']);
      }).catch(function () { window.location.href = root + 'cart'; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

  var toast = document.querySelector('.hoh-toast');
  var alertMsg = function (msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(alertMsg._t); alertMsg._t = setTimeout(function () { toast.hidden = true; }, 3200);
  };

  /* add to basket: takes over from hoh.js so the basket slides open */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-hoh-add]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fid = form.getAttribute('id');
    var btns = fid ? document.querySelectorAll('[form="' + fid + '"], #' + fid + ' [type="submit"]') : form.querySelectorAll('[type="submit"]');
    [].forEach.call(btns, function (b) { b.disabled = true; });
    var fd = new FormData(form);
    fd.delete('hoh_ful');
    fd.append('sections', 'hoh-cart-drawer');
    var added = false;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alertMsg(res.j.description || res.j.message || 'Could not add to basket'); return; }
        added = true;
        if (onCartPage) { window.location.reload(); return; }
        if (res.j.sections && res.j.sections['hoh-cart-drawer']) swap(res.j.sections['hoh-cart-drawer']);
        else return refresh();
      })
      .then(function () { if (added && !onCartPage) { count(); openDrawer(); } })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); })
      .finally(function () { [].forEach.call(btns, function (b) { b.disabled = false; }); });
  }, true);
})();
